export function buildBundledConfig(
  env: Record<string, string | undefined> = {},
  { LOGGER_SOURCE = '¢', PORT = '3001', VERSION = 'next' } = {},
) {
  /**
   * !!! IMPORTANT --- NEVER SHARE SECRETS HERE --- IMPORTANT !!!
   *
   * Add any additional global configuration in the object below.
   * This object is injected in the client & server as the `clientConfig` global.
   *
   * --- Keep in mind the following rules ---
   *
   * For booleans, always compare with 'true', ex:
   *  env.NEXT_PUBLIC_USE_EXAMPLE === 'true'
   *
   * For numbers, use parseInt or Number constructor to convert strings to numbers, ex:
   *  parseInt(env.NEXT_PUBLIC_EXAMPLE_NUMBER || '20000')
   *
   * Every input from env is either a string or undefined.
   */
  const NEXT_PUBLIC_MODE = env.NEXT_PUBLIC_MODE || 'production';
  const IS_DEVELOPMENT = NEXT_PUBLIC_MODE === 'development';
  const DEFAULT_LANGUAGE = env.DEFAULT_LANGUAGE || 'en';
  const PUBLIC_URL =
    env.NEXT_PUBLIC_URL || (env.VERCEL_URL && `https://${env.VERCEL_URL}`) || `http://localhost:${PORT}`;
  return {
    // Core
    NEXT_PUBLIC_MODE,
    VERSION,
    DEFAULT_LANGUAGE,
    PUBLIC_URL,
    API_URL: env.NEXT_PUBLIC_API_URL || '/api',
    // WebSockets
    WS_URL:
      env.NEXT_PUBLIC_WS_URL || (IS_DEVELOPMENT ? PUBLIC_URL.replace('http', 'ws').replace('https', 'wss') : undefined),
    WS_LOGGER_SOURCE: env.NEXT_PUBLIC_WS_LOGGER_SOURCE || LOGGER_SOURCE,
    // Auth
    ENABLE_AXIOS_CREDENTIALS: env.NEXT_PUBLIC_ENABLE_AXIOS_CREDENTIALS === 'true',
    NEXT_PUBLIC_WP_SUPPORT_PHONE_NUMBER: env.NEXT_PUBLIC_WP_SUPPORT_PHONE_NUMBER,
    NEXT_PUBLIC_WP_SUPPORT_EMAIL: env.NEXT_PUBLIC_WP_SUPPORT_EMAIL,
  };
}
